import { Controller } from "@hotwired/stimulus"

// The toast after a merge from the inbox: Undo for the seconds it has
// left, counted down beside it, then the toast goes (as flash toasts do).
export default class extends Controller {
  static values = { seconds: Number }
  static targets = ["clock"]

  connect() {
    this.left = this.secondsValue
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    if (this.left <= 0) return this.dismiss()
    this.clockTarget.textContent = `${Math.floor(this.left / 60)}:${String(this.left % 60).padStart(2, "0")}`
    this.left -= 1
  }

  dismiss() {
    clearInterval(this.timer)
    this.element.classList.add("opacity-0", "translate-y-2")
    setTimeout(() => this.element.remove(), 300)
  }
}
